<template lang="pug">
  .tag-item(
    :class=`{ 'item--selected': id === selectedTagId }`,
    @click='select(id)'
  ) {{ text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('tag', [
      'selectedTagId'
    ])
  },
  methods: {
    ...mapActions('tag', [
      'select'
    ])
  }
}
</script>

<style scoped>
.tag-item {
  font-weight: bold;
  text-transform: uppercase;
  color: #776E65;
  font-size: 11px;
  line-height: 30px;
  background-color: #EDE0C8;
  padding: 0 10px;
  margin: 2px;
  cursor: pointer;
  box-sizing: border-box;
  border-left: 2px solid transparent;
}
.tag-item:hover {
  border-left-color: #F2B179;
}
.item--selected {
  border-left-color: #f00 !important;
  color: #F9F6F2;
  background-color: #F2B179;
}
</style>
